import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'

import { DashboardNavigationBar } from '@/components/layouts/dashboard'
import { UserNavItems } from '@/config/nav'

export const Route = createFileRoute('/_liff/_dashboard')({
  component: RouteComponent,
})

function RouteComponent() {
  const { pathname } = useLocation()
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [pathname])

  return (
    <div className="flex h-dvh flex-1 flex-col">
      <div
        ref={scrollRef}
        className="flex-1 overflow-x-hidden overflow-y-auto"
      >
        <Outlet />
      </div>
      <DashboardNavigationBar items={UserNavItems} />
    </div>
  )
}
